import { render } from "./Channel.vue?vue&type=template&id=6ae67045&scoped=true"
import script from "./Channel.vue?vue&type=script&lang=js"
export * from "./Channel.vue?vue&type=script&lang=js"

import "./Channel.vue?vue&type=style&index=0&id=6ae67045&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae67045"]])

export default __exports__